import { makePostRequest, getUrl } from '../utils';
import { getTotalPageViews } from './pageviews';
import { SequenceAnalytics } from './sequences';
import { proberAnalytics } from './prober';
import { prebidAnalytics } from './prebid';
import { getBrowsingTopics } from './topics';
import { ANALYTICS_URL } from '../constants';
import { HttpError } from 'src/utils/http';
import { AnalyticsPayload, MatchedAudience } from '../types';

export declare const DISABLE_ANALYTICS: boolean;
export declare const DISABLE_VIEWS_COUNTS: boolean;

export const logAnalytics = async (
  consentGranted: boolean,
  matchedAudiences: MatchedAudience[],
  featuresAvailable: boolean | undefined,
  pagesResponse?: {
    error: HttpError | undefined;
  },
  audiencesResponse?: {
    error: HttpError | undefined;
  }
): Promise<void> => {
  if (DISABLE_ANALYTICS) return;

  const { apiKey, accountId, publisherId, loadId } = (window as any)
    .edktInitializor;

  const url = getUrl();
  const [prober, toSequence, topics] = await Promise.all([
    proberAnalytics.get(),
    prebidAnalytics(),
    getBrowsingTopics(),
  ]);

  const sequenceAnalytics = new SequenceAnalytics(loadId);
  const sequences = sequenceAnalytics.get(toSequence);
  const totalPageViews = getTotalPageViews();
  // TODO: obfuscate the payload key names.
  // But document in the code / types.
  const payload: AnalyticsPayload = {
    url,
    accountId,
    publisherId,
    consentGranted,
    matchedAudiences,
    prober,
    ...(sequences && { sequences }),
    featuresAvailable,
    totalPageViews,
    topics,
    documentReferrer: document.referrer,
    isPagesError: !!pagesResponse?.error,
    pagesErrorCode: pagesResponse?.error?.code,
    pagesErrorMessage: pagesResponse?.error?.message,
    isAudiencesError: !!audiencesResponse?.error,
    audiencesErrorCode: audiencesResponse?.error?.code,
    audiencesErrorMessage: audiencesResponse?.error?.message,
  };

  await makePostRequest(ANALYTICS_URL, JSON.stringify(payload), apiKey, loadId);
};

export const logDwellAnalytics = (_dwellTime: number): void => {
  // NOTE: Disable the `dwell` event in scope of https://github.com/AirGrid/rmap/issues/2740
  // It can be removed after logs and cost analysis.
  // const { loadId } = (window as any).edktInitializor;
  // sendBeacon(ANALYTICS_DWELL_URL, JSON.stringify({ loadId, dwellTime }));
};
